import {Component, OnDestroy, OnInit, ViewContainerRef} from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { HookResult, Transition, TransitionService } from "@uirouter/angular";
import {ViewService} from './services/view.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ModalService } from './modals/modal.service';
import { interval, Subscription } from 'rxjs';
import { mergeMap, startWith } from 'rxjs/operators';
import { BannerService, DateHelpers, EdlAlert, PortalService, SessionService } from '@edl-development/edl-common';
import { multiFactor } from 'firebase/auth';
declare let gtag: Function;
@Component({
    selector: 'edl-comply',
    templateUrl: 'edl-comply.component.html',
    encapsulation: ViewEncapsulation.None
})

export class EdlComplyComponent implements OnInit, OnDestroy{
    maintenanceNotification: Subscription;

    constructor(
        private viewService: ViewService,
        private vcr: ViewContainerRef,
        private transitionService: TransitionService,
        private modalService: ModalService,
        private loadingBarService: LoadingBarService,
        private portalService: PortalService,
        private bannerService: BannerService,
        public sessionService: SessionService
    ) {
        viewService.viewContainerRef = vcr;

        let firebaseConfig = {
          apiKey: "AIzaSyC6Oyps1jsm38LpaAEMHiq4KapSZJZZ5ls",
          authDomain: "edl-identity.firebaseapp.com"
      };

      this.sessionService.InitializeAuth(firebaseConfig, "");

        transitionService.onSuccess({ }, (transition) => {
            try {
                gtag('set', 'page_path', window.location.pathname);
                gtag('event', 'page_view');
            } catch (e){ }

            this.sessionService.closeMenu();
        });

        transitionService.onSuccess({ }, () => {
            if(this.sessionService.isAuthenticated() ) {
                this.sessionService.Initialized(true);
            }
            this.loadingBarService.stop();
        });

        transitionService.onError({}, (transition: Transition) => {
            const to = transition.to();
            const error = transition.error();
            const params = transition.params();

            this.loadingBarService.useRef().stop();
            // If the error occured due to the user being on the wrong portal
            // then ask the user to switch portals
            if(error?.detail?.error?.PortalID) {
                this.modalService.wrongPortal(error.detail.error, to, params)

            // If an error occurs due to the user not having permission to access the page
            // then take them to the unauthorized page
            } else if(error?.detail?.status === 401 || error?.detail?.status === 403) {
                transition.router.stateService.go('public.unauthorized');
            } else if ((error?.detail?.status ?? 0) >= 400) {
                transition.router.stateService.go('public.generic-error');
            }
        });

        transitionService.onBefore({}, async (transition) => {
            const from = transition.from();
            const to = transition.to();
            const isPublic = to?.data?.isPublic;


            if (!isPublic && this.sessionService.isAuthenticated() && sessionService.userAgreement && to.name !== 'public.user-agreement') {
              return transition.router.stateService.target('public.user-agreement');
            }

            else if(!isPublic && this.sessionService.mfar && (to.name !== 'authenticated.switch-portals' && to.name !== 'authenticated.users.user.edit' && to.name !== 'public.user-agreement')){
              return await this.checkAuthState(transition);
            }


            if (from.name !== to.name) {
                this.loadingBarService.set(0);
                this.loadingBarService.start();
            }

        });
    }


    async checkAuthState(transition:Transition){
      return await  new Promise<HookResult>((resolve, reject) => {
        this.sessionService.GetAuthApp().onAuthStateChanged(authUser => {
          const loggedInPortal = this.sessionService.PortalSettings?.URLSubdirectory;
          const user = this.sessionService.user;
          try{
            var AuthUser = this.sessionService.GetAuthApp().currentUser!;
            const multiFactorUser = multiFactor(AuthUser);
            if(multiFactorUser.enrolledFactors.length === 0 || !user?.SQPresent){
              resolve( transition.router.stateService.target('authenticated.users.user.edit', {loggedInPortal, userId: user?.UserID}));
            }
            resolve(undefined);
          } catch (e){
            resolve(undefined);
          }

        });
      });
  }

    ngOnInit() {
        // Check for maintenance notification every 10 minutes
        this.maintenanceNotification = interval(600000)
            .pipe(
                startWith(0),
                mergeMap(() => this.portalService.getAlert())
            ).subscribe((alert: EdlAlert) => {
                const currentMessage = alert?.AlertMessage;
                const currentSeverity = alert?.AlertSeverity;
                const previousMessage = this.bannerService.getMessage();
                const previousSeverity = this.bannerService.getSeverity();

                const startDate = DateHelpers.shortDateStringToDate(alert?.StartDate);
                const endDate = DateHelpers.shortDateStringToDate(alert?.EndDate);
                const today = DateHelpers.getDateWithoutTime(new Date());

                if ((previousMessage !== currentMessage || previousSeverity !== currentSeverity) &&
                    currentMessage &&
                    alert.IsActive &&
                    DateHelpers.isDateBetween(today, startDate, endDate)){
                    this.bannerService.setMessage(currentMessage);
                    this.bannerService.setSeverity(currentSeverity);
                    this.bannerService.open();
                }
            });
    }

    ngOnDestroy() {
        this.maintenanceNotification.unsubscribe();
    }
}
